import React, { useContext } from "react";
import { ThemeContext } from "../theme/ThemeProvider"; // adjust import path if needed
import { Col, Row } from "react-bootstrap";
import {
  DiReact,
  DiGit,
  DiBootstrap,
} from "react-icons/di";
import {
  SiFirebase,
  SiJavascript,
  SiExpress,
  SiMongodb,
} from "react-icons/si";
import './Skils.css'; // Import the CSS file
import { FaGithub, FaHtml5, FaNode } from "react-icons/fa";
import { IoLogoCss3 } from "react-icons/io";
import { RiTailwindCssFill } from "react-icons/ri";
import { CgFigma } from "react-icons/cg";
import { TextDecrypt } from "../content/TextDecrypt"; // assuming TextDecrypt is used for animated text

const greetings = "Skills";

function Skils() {
  const { theme } = useContext(ThemeContext); // get the current theme

  // Define styles based on the theme
  const textStyle = {
    color: theme === "light" ? "#000" : "#fff", // Light theme text is black, dark theme text is white
  };

  return (
    <div id="skills">
      <div className="about-title" style={textStyle}>
        <TextDecrypt text={greetings} />
      </div>
      <div className="text-center">
        <Row className="row-center">
          <Col xs={4} md={2} className="tech-icons">
            <FaHtml5 /> <h3>HTML5</h3>
            <div className="tooltip tooltip1">HTML5</div>
          </Col>
          <Col xs={4} md={2} className="tech-icons">
            <IoLogoCss3 /> <h3>CSS3</h3>
            <div className="tooltip tooltip2">CSS3</div>
          </Col>
          <Col xs={4} md={2} className="tech-icons">
            <RiTailwindCssFill />  <h3>Tailwind CSS</h3>
            <div className="tooltip tooltip3">CSS</div>
          </Col>
          <Col xs={4} md={2} className="tech-icons">
            <DiBootstrap />  <h3>Bootstrap</h3>
            <div className="tooltip tooltip3">Bootstrap</div>
          </Col>
          <Col xs={4} md={2} className="tech-icons">
            <SiJavascript />  <h3>Javascript</h3>
            <div className="tooltip tooltip4"></div>
          </Col>
          <Col xs={4} md={2} className="tech-icons">
            <DiReact /> <h3>React</h3>
            <div className="tooltip tooltip5">React</div>
          </Col>
          <Col xs={4} md={2} className="tech-icons">
            <FaNode /> <h3>Node.js</h3>
            <div className="tooltip tooltip6">Node.js</div>
          </Col>
          <Col xs={4} md={2} className="tech-icons">
            <SiExpress /> <h3>Express</h3>
            <div className="tooltip tooltip7">Express</div>
          </Col>
          <Col xs={4} md={2} className="tech-icons">
            <SiMongodb /> <h3>MongoDB</h3>
            <div className="tooltip tooltip8">Next.js</div>
          </Col>
          <Col xs={4} md={2} className="tech-icons">
            <SiFirebase /> <h3>Firebase</h3>
            <div className="tooltip tooltip10">Firebase</div>
          </Col>
          <Col xs={4} md={2} className="tech-icons">
            <DiGit /> <h3>Git</h3>
            <div className="tooltip tooltip9">Git</div>
          </Col>
          <Col xs={4} md={2} className="tech-icons">
            <FaGithub /> <h3>Github</h3>
            <div className="tooltip tooltip11">Github</div>
          </Col>
          <Col xs={4} md={2} className="tech-icons">
            <CgFigma /> <h3>Figma</h3>
            <div className="tooltip tooltip12">Figma</div>
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default Skils;
